export default "__VITE_ASSET__BlV4MmN8__"